let amplitudeInstance: any = null;

export const getAmplitudeService = async () => {
  if (amplitudeInstance) return amplitudeInstance;

  const { track, setIdentity } = await import(
    "@amplitude/analytics-browser"
  );

  amplitudeInstance = {
    setUser: (userStore: any, account?: any) => {
      setIdentity({
        userId: userStore.auth.userdata.id || null,
        userProperties: {
          'Email Address': userStore.auth.userdata.email,
        
          'User Type':
            (userStore.getIsTrailAccount && userStore.getIsTrialExpired)
              ? 'Free Trial Expired'
              : userStore.getIsTrailAccount
              ? 'Free Trial User'
              : 'Subscriber',
        
          ...(userStore.getTrailPackageFeatures?.mmc?.package_name && {
            'Subscription Package MMC':
              userStore.getTrailPackageFeatures.mmc.package_name,
          }),
        
          ...(userStore.getTrailPackageFeatures?.mcc?.package_name && {
            'Subscription Package MCC':
              userStore.getTrailPackageFeatures.mcc.package_name,
          }),
        
          ...(userStore.getTrailPackageFeatures?.msc?.package_name && {
            'Subscription Package MSC':
              userStore.getTrailPackageFeatures.msc.package_name,
          }),

          ...(account?.cluster && {
            Cluster: account.cluster,
          }),

          'First Time Login': userStore.auth.firstLoginAt ? false : true,
          
          ...(userStore.getNetoStores.length > 0 && {
            'Tenancy ID': userStore.getNetoStores.map((store: any) => store.path.split('/').pop()),
          }),
        }
      });
    },

    trackEvent: (
      eventName: string,
      eventProperties?: Record<string, unknown>
    ) => {
      track(eventName, eventProperties || {});
    },
  };

  return amplitudeInstance;
};